export default __webpack_public_path__ + "static/media/icon-document.41473b93.svg";